<!--客户管理-客户列表 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea ClientList">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索框 -->
        <div class="searchBox">
          <el-input
            class="searchInput"
            placeholder="请输入企业名称"
            v-model="paging.search_str"
            clearable>
          </el-input>
          <el-button
            class="searchBtn"
            type="primary"
            @click="getClientList('search')">搜 索</el-button>
        </div>

        <!-- 添加客户信息 -->
        <div class="addButton">
          <el-button type="primary" @click="operateDialogInfo('add')">添加</el-button>
        </div>

        <!--客户信息table-->
        <div class="clientListTable">
          <el-table
            v-loading="loading"
            :data="clientList"
            style="width: 96%"
            :row-class-name="getRowClass">
            <!-- 展开显示子公司列表 -->
            <el-table-column type="expand">
              <template slot-scope="props">
              <!-- 子公司列表表格 -->
              <el-table
                v-loading="loading"
                :data="props.row.agent_list"
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  width="80"
                  >
                </el-table-column>
                <el-table-column
                  label="下级公司"
                  width="100">
                  <template slot-scope="scope">
                    <el-button type="text" @click="goEnterprisePlatform(scope.row)">{{scope.row.company_name}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="user_account"
                  label="账号"
                  >
                </el-table-column>
                <el-table-column
                  prop="detail_address"
                  label="公司地址">
                </el-table-column>
                <el-table-column
                  prop="email"
                  label="邮箱">
                </el-table-column>
                <el-table-column
                  prop="create_time"
                  label="创建时间">
                </el-table-column>
                <el-table-column
                  label="状态">
                  <template slot-scope="scope">
                    <span>{{ scope.row.company_state == '1' ? '正常' : '禁用'}}</span>
                  </template>
                </el-table-column>
              </el-table>
              </template>
            </el-table-column>
            <el-table-column
              type="index"
              label="序号"
              width="80">
            </el-table-column>
            <el-table-column
              label="企业名称"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button type="text" @click="goEnterprisePlatform(scope.row)">{{scope.row.company_name}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="user_account"
              label="账号">
            </el-table-column>
            <el-table-column
              prop="detail_address"
              label="公司地址" show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column
              prop="phone_no"
              label="手机号码"
              width="190">
            </el-table-column> -->
            <el-table-column
              prop="email"
              label="邮箱"
              width="190">
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间">
            </el-table-column>
            <el-table-column
              prop="sms_type_name"
              label="短信服务商">
            </el-table-column>
            <el-table-column
              label="代理商"
              width="70">
                <template slot-scope="scope">
                  <span>{{ scope.row.is_agency == '1' ? '是' : '否'}}</span>
                </template>
            </el-table-column>
            <el-table-column
              label="状态"
              width="60">
              <template slot-scope="scope">
                <el-button type="text" @click="operateDialogInfo('changeStatus',scope.row)">{{ scope.row.company_status_name}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="密码"
              width="60">
              <template slot-scope="scope">
                <el-button type="text" @click="operateDialogInfo('reset',scope.row)">重置</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="operateDialogInfo('alter', scope.row)">修改</el-dropdown-item>
                    <el-dropdown-item @click.native="ClientAuthAllot(scope.row.company_id)">权限分配</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-button type="text" @click="operateDialogInfo('alter', scope.row)">修改</el-button>
                <el-button type="text" @click="ClientAuthAllot(scope.row.company_id)">权限分配</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <div class="paging" v-if="paging.pageCount > 1">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="paging.page"
            layout="prev, pager, next, jumper"
            :page-count="paging.pageCount">
          </el-pagination>
        </div>

        <!--对话框-->
        <el-dialog
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">
          
          <!-- 状态 -->
          <div
            class="changeStatusWrapper"
            v-if="dialogData.type === 'changeStatus'">
            <p class="text">
              当前客户状态为
              <span class="bold">
                {{dialogData.info.company_status_name}}
              </span>
            </p>
            <p class="text">
              是否将状态改为
              <span class="bold">
                {{dialogData.info.company_state === '1' ? '禁用' : '正常'}}？
              </span>
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="changeClientStatus()">{{dialogData.info.company_state === '1' ? '禁用' : '正常'}}</el-button>
            </div>
          </div>

          <!-- 重置密码 -->
          <div
            class="changeStatusWrapper"
            v-else-if="dialogData.type === 'reset'">

            <!-- 询问客户是否重置密码 -->
            <p
              class="text" v-if="!dialogData.isReset">
              是否需要重置密码？
            </p>
            <!-- 已确认重置密码 -->
            <p class="text" v-else>新密码已经通过邮件形式发送到该客户邮箱里!</p>

            <div slot="footer" class="dialog-footer" v-if="!dialogData.isReset">
              <el-button @click="dialogData.visible = false">否</el-button>
              <el-button @click="resetClientPassword()">是</el-button>
            </div>
          </div>

          <!-- 添加或修改客户信息 -->
          <div v-else class="cont_dio">
            <el-form
              label-width="130px"
              :model="dialogData.info">
              <el-form-item label="企业名称:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.company_name"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="企业logo:">
                <div class="inputBox">
                  <!-- <input type="file" value="点击上传" @change="getFile"> -->
                  <el-upload
                    action="string"
                    accept="image/*"
                    :show-file-list=false
                    :on-exceed="handleExceed"
                    :http-request="uploadFile">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <span v-if="dialogData.info.logo_url==''">未选择文件</span>
                    <img class="logo" :src="dialogData.info.logo_url" alt="logo" v-else />
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item label="企业代号:">
                <div class="inputBox">
                  <p class="inputDeposit" style="padding-left:15px;" v-if="dialogData.type=='alter'">{{dialogData.info.company_ic}}</p>
                  <el-input class="inputDeposit" v-model="dialogData.info.company_ic" :maxlength=4 placeholder="选填，限制四位字母" v-else></el-input>
                </div>
              </el-form-item>
              <el-input style="position:fixed;bottom:-9999px"></el-input>
              <el-input type="password" style="position:fixed;bottom:-9999px"></el-input>
              <el-form-item label="账号:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.user_account" placeholder="字母或者数字的组合，限制6~15位" autocomplete="new-user"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="密码:">
                <div class="inputBox" v-if="dialogData.info.isAlter">
                  <el-input class="inputDeposit" v-model="dialogData.info.password" type="password" show-password autocomplete="new-pass" placeholder="[要更改保存的密码，请单击这里]"></el-input>
                </div>
                <div class="inputBox" v-else>
                  <el-input class="inputDeposit" v-model="dialogData.info.password" type="password" show-password autocomplete="new-pass"></el-input>
                </div>
              </el-form-item>
              <!-- <el-form-item label="手机号码:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.phone_no" placeholder="手机号码" autocomplete="new-phone"></el-input>
                </div>
              </el-form-item> -->
              <el-form-item label="地址:">
                <div class="areaflex">
                  <el-select class="inputDeposit" v-model="dialogData.info.address_info.province" placeholder="省" @focus="getAreaList('province','1')">
                    <el-option v-for="(item,index) in provinceData" :label="item.name" :value="item.id" :key="index"></el-option>
                  </el-select>
                  <el-select class="inputDeposit" v-model="dialogData.info.address_info.city" placeholder="市" @focus="getAreaList('city',dialogData.info.address_info.province)">
                    <el-option v-for="(item,index) in cityData" :label="item.name" :value="item.id" :key="index"></el-option>
                  </el-select>
                  <el-select class="inputDeposit" v-model="dialogData.info.address_info.area" placeholder="区" @focus="getAreaList('area',dialogData.info.address_info.city)">
                    <el-option v-for="(item,index) in areaData" :label="item.name" :value="item.id" :key="index"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="具体街道:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.address_info.address"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="邮箱:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.email"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="短信服务商:">
                <div class="inputBox">
                  <el-select class="inputDeposit" v-model="dialogData.info.sms_type">
                    <el-option label="请选择短信服务商" value="0"></el-option>
                    <el-option :label="item" :value="index" v-for="(item, index) in smsTypeList" :key="index"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="dialogData.info.is_agency_status">设置为代理商</el-checkbox>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="confirm()">确 认</el-button>
            </div>
          </div>
        </el-dialog>
              
      </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { 
      updataBreadCrumb,
      showToast,
      showLoading,
      hideLoading,
      deepCopy
    } from "../../../../static/js/utility/utility.js"
  import { maintainApi, clientMApi } from "../../../../static/js/api.js"
  import { epAutoLoginUrl, epVisitUrl, commomHeaders } from "../../../../static/js/config.js"

  export default {
    name: 'ClientList',
    components: {
      BreadCrumb
    },

    data() {
      return {
        // 短信类型列表
        smsTypeList: {
          '1': '蜂助手',
          '2': '云通讯',
          '3': '移动短信',
          '4': 'Twilio'
        },

        // 分页数据  page为当前页，perPage为每页数量 ,search_str为搜索字段
        paging: {
          page: 1,
          perPage: 10,
          search_str: ''
        },

        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          isReset: false,
          info: {
            address_info:{}
          },

        },


        provinceData:[],
        cityData:[],
        areaData:[],

        // 客户列表
        clientList: [],
        loading: true
      }
    },

    created: async function () {
    },

    mounted(){
      this.getClientList()
    },

    methods: {
      // 获取城市/地区列表
      async getAreaList(type, id) {
        let that = this
        that.provinceData=[]
        that.cityData=[]
        that.areaData=[]
        // 判断上级地址是否选择
        if (id === '' && (type === 'city' || type === 'area')) {
          showToast(type === 'city' ? '请先选择省' : '请先选择市')
          return
        }
        let data = {
          id: id
        }
        let res = await clientMApi.getAreaList(data)
        if (res.meta.code === 200) {
          if (type === 'province') {
            that.provinceData = res.data
          } else if (type === 'city') {
            that.cityData = res.data
          } else if (type === 'area') {
            that.areaData = res.data
          }

        } else {
          showToast(res.meta.message)
        }
      },

      getRowClass(row) {
        // let res = []
        // console.log(row)
        if (row.row.agent_list == ''){
          // res.push('noChild')
          return 'noChild'
        }
      },

      // 操作客户信息dialogData
      operateDialogInfo: function (type, info) {
        let that = this
        let infoNull = {
          company_name: '' ,
          logo_url: '',
          company_ic: '',
          user_account:'',
          password: '',
          phone_no:'',
          email: '',
          sms_type: '0',
          address_info:{
            country:'1',
            province:'',
            city:'',
            area:'',
            address:'',
          }
        }
        if(type == 'alter'){
          info.password=''
          info.isAlter = '1'
          if(info.address_info==''){
            info.address_info={
              country:'1',
              province:'',
              city:'',
              area:'',
              address:'',
            }
          }else{
            that.getAreaList('province','1')
            that.getAreaList('city',info.address_info.province)
            that.getAreaList('area',info.address_info.city)
          }
        }
        // this.getAreaList('province','1')
        this.dialogData = {
          type: type,
          title: type === 'changeStatus' ? '' : type === 'add' ? '添加客户信息' : type === 'alter' ? '修改客户信息' : '重置密码',
          visible: !(this.dialogData.visible),
          isReset: false,
          info: info ? deepCopy(info) : infoNull
        }
        // console.log('this', this.dialogData)
      },

      
      // 当前页值改变，获取新的客户列表
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.getClientList()
      },

      // 重置客户密码
      resetClientPassword: async function () {
        let vm = this
        let data = {
          company_id: vm.dialogData.info.company_id
        }
        let res = await clientMApi.resetClientPassword(data)
        if (res.meta.code === 200) {
          this.dialogData.isReset = !(this.dialogData.isReset)
        } else {
          showToast(res.meta.message)
        }
      },

      // 修改客户状态
      changeClientStatus: async function () {
        let vm = this
        let data = {
          company_id: vm.dialogData.info.company_id
        }
        let res = await clientMApi.changeClientStatus(data)
        if (res.meta.code === 200) {
          this.dialogData.visible = !(this.dialogData.visible)
          showToast('修改成功')
          vm.getClientList()
        } else {
          showToast(res.meta.message)
        }
      },

      // 自定义上传logo
      uploadFile: async function (content) {
        // console.log('content', content)
        let vm = this
        let formData = new FormData()
        formData.append('file', content.file)
        let res = await clientMApi.uploadFile(formData) 
        if (res.meta.code === 200) {
          showToast('上传成功')
          vm.dialogData.info.logo_url = res.data
        } else {
          showToast(res.meta.message)
        }
      },

      // 上传文件不能超出一个
      handleExceed(files, fileList) {
        showToast(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
        // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },

      // 更新员工信息
      updateClient: async function (data) {
        let vm = this
        let res = await clientMApi.updateClient(data)
        if (res.meta.code === 200) {
          showToast(data.company_id === '' ? '添加成功' : '修改成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getClientList()
        } else {
          showToast(res.meta.message)
        }
        // console.log('res', res)
      },

      // 确认更新员工信息
      confirm: function () {
        let vm = this
        // console.log('is_agency', vm.dialogData.info)
        // return
        let data = {
          company_id: vm.dialogData.type === 'add' ? '' : vm.dialogData.info.company_id ,
          company_name: vm.dialogData.info.company_name ,
          // phone_no: vm.dialogData.info.phone_no,
          email: vm.dialogData.info.email,
          user_account: vm.dialogData.info.user_account,
          sms_type: vm.dialogData.info.sms_type,
          is_agency: vm.dialogData.info.is_agency_status ? '1' : '0',
          province: vm.dialogData.info.address_info.province,
          city: vm.dialogData.info.address_info.city,
          area: vm.dialogData.info.address_info.area,
          country: '1',
          address: vm.dialogData.info.address_info.address,
          logo_url: vm.dialogData.info.logo_url,
          company_ic: vm.dialogData.info.company_ic,
        }
        if(vm.dialogData.info.isAlter){
          if(vm.dialogData.info.password){
            data.password= vm.dialogData.info.password
          }
        }else{
          data.password= vm.dialogData.info.password
        }
        // console.log('员工数据', data)
        // return
        // 判断值
        if (data.company_name === '') {
          showToast('企业名称不能为空！')
          return false
        }
        let reUser = new RegExp(/^[0-9a-zA-Z]{6,15}$/)
        if (data.user_account === '') {
          showToast('账号不能为空！')
          return
        } else if (!reUser.test(data.user_account)) {
          showToast('请填写6-15位字母和数字组合的账号')
          return
        }
        let rePass = new RegExp(/^[\w]{6,20}$/)
        if (data.password === '') {
          showToast('密码不能为空！')
          return
        } else if (!rePass.test(data.password)) {
          showToast('请填写6-20位字母、数字和下划线组合的密码')
          return
        }
        // let rePhone = new RegExp( /^1[3|4|5|7|8|9][0-9]\d{8}$/)
        // if (data.phone_no === '') {
        //   showToast('手机号码不能为空！')
        //   return false
        // }else if(!rePhone.test(data.phone_no)){
        //   showToast('请填写11位有效的手机号码')
        //   return
        // }
        if (data.email === '') {
          showToast('邮箱不能为空！')
          return false
        }
        if (data.transfer_server === '') {
          showToast('中转服务器地址不能为空！')
          return false
        }
        if (data.mqtt_server === '') {
          showToast('MQTT服务器地址不能为空！')
          return false
        }
        vm.updateClient(data)
        // console.log(this.dialogData.info);
      },

      // 数据处理
      processData: function (data) {
        let list = [...data.list]
        // console.log('list', list)
        for (let i in list) {
          let listItem = list[i]
          // 获取状态
          list[i].company_status_name = listItem.company_state == '1' ? '正常' : '禁用'
          list[i].sms_type_name = listItem.sms_type == '0' ? '未设置' : this.smsTypeList[listItem.sms_type]
          list[i].is_agency_status = listItem.is_agency == '1' ? true : false
        }
        this.clientList = list
        // 总页码
        this.paging.pageCount = data.pageCount
      },

      // 获取客户信息列表
      getClientList: async function (isSearch) {
        // console.log('12', this.paging.search_str)
        let vm = this
        let data = {
          page: this.paging.page,
          perPage: this.paging.perPage,
          search_str: this.paging.search_str
        }
        // 搜索列表，page默认为1
        if (isSearch) {
          data.page = '1' 
        } 

        // console.log('this.paging', data)
        vm.loading = true
        let res = await clientMApi.getClientList(data)
        vm.loading = false
        if (res.meta.code === 200) {
          vm.processData(res.data)
        } else {
          showToast(res.meta.message)
        }
      },

      // 权限分配
      ClientAuthAllot(company_id) {
        // console.log('company_id: ',company_id);
        let navBarActive = [{function_tab: 'ClientAuthAllot', function_name: '权限分配'}]
        // 更新面包屑内容
        updataBreadCrumb(3, navBarActive)
        this.$router.push({
          path: '/ClientAuthAllot',
          query: {company_id: company_id}
        })
      },

      // 
      // goEnterprisePlatform: function (row) {
      //   console.log('row', row)
      //   this.enterprisePlatformAutoLogin(data)
      // },

      // 跳转企业平台，自动登录
      goEnterprisePlatform: function (row) {
        let vm = this
        let data = {
          company_id: row.company_id,
          token: row.token
        }

        showLoading('正在跳转')
        axios({
          method: 'post',
          url: epAutoLoginUrl,
          headers: commomHeaders,
          data: data
        })
          .then(function (res) {
            hideLoading()
            vm.autoLoginSuccess(res.data)
          })
          .catch(function (error) {
            hideLoading()
            showToast('连接服务器失败，取消操作请重试！')
            // console.log('error', error)
          })
      },


      autoLoginSuccess: function (res) {
        if (res.meta.code === 200) {
          // 登录成功，进入后台 (1为仪表盘，2为默认首页)
          // encodeURIComponent对参数进行编码，避免参数携带&字符被截断
          let host = epVisitUrl.replace(/\/+$/g, "") + '#';
          let path = host + '?eUserInfo=' + encodeURIComponent(JSON.stringify(res.data))
          showToast('验证成功')
          setTimeout(function () {
            window.open(path, "_blank")
          },
 500);
        } else {
          showToast(res.meta.message)
        }
      }
    },

    watch: {
      // 监听搜索字段，清空更新客户列表
      'paging.search_str': function (newVal) {
        if (newVal === '') {
          this.getClientList()
        }
        // console.log('tag', this.paging.search_str)
      },

    }
  }
</script>

<style lang="scss">
.ClientList{
  .cont_dio{
    .el-form-item{
      margin-bottom: 15px;
    }
    .logo {
      width: 50px;
    }
  }
  .areaflex{
    display: flex;
    width: 100%;
    .inputDeposit{
      width: 30%;
      padding-right: 10px;
      box-sizing: border-box;
      &:last-child{
        padding:0; 
      }
    }
  }
  .el-table__expanded-cell:hover{
    background-color: #fff!important;
  }
  .noChild .el-table__expand-column .el-table__expand-icon {
    display: none;
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 300px;
      margin-right: 30px;
    }
  }

  .addButton {
    margin-bottom: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/ClientManage/ClientList.vue